var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import Debounce from "debounce-decorator";
import { Icon, Animate, Loader } from "sb-resp-ui";
import * as CMP from "./components";
/* TODO(developer): refactor to lower cyclomatic complexity */
/* tslint:disable:cyclomatic-complexity */
const defaultStep = 450;
let RacingNextRaces = class RacingNextRaces extends React.Component {
    constructor(props) {
        super(props);
        this.calcs = {
            step: defaultStep,
            container: 0,
            wrapper: 0
        };
        this.anims = { left: 0 };
        this.dict = this.props.dict;
        this.state = {
            scrollable: {
                left: false,
                right: false
            },
            animation: {
                x: 0,
                duration: 0.6,
                ease: "back.out(0.7)"
            },
            dataProvider: this.props.dataProvider
        };
        this.cachedState = {
            branchId: this.state.dataProvider.racingStore.branchId,
            regionId: this.state.dataProvider.racingStore.regionId
        };
    }
    /* istanbul ignore next */
    renderCardItem(item) {
        /* istanbul ignore next */
        return (React.createElement(CMP.Item, { key: item.id, url: item.url, handler: (event) => { item.handler(event); }, label: this.dict.ViewAll },
            React.createElement(CMP.Name, { title: item.title, hasLiveStream: item.hasLiveStream }),
            item.rows.length > 0 && this.renderCardRows(item.rows),
            item.rows.length === 0 && this.renderLoader(true)));
    }
    /* istanbul ignore next */
    renderCardRow(row) {
        let betButtonOdds = row.odds;
        if (row.isNR) {
            betButtonOdds = this.props.dict.NonRunner;
        }
        else if (row.isSP) {
            betButtonOdds = this.props.dict.StartingPrice;
        }
        let chosenClass = this.state.dataProvider.isLineInBetSlip(row.id, row.eventId) ? "chosenBet" : "";
        let modifier = `rj-racing-next-races__button ${this.state.dataProvider.provider.getUniqueOddsClass(row.id, true)} ${chosenClass} `;
        /* istanbul ignore next */
        return (React.createElement(CMP.Row, { id: row.id, key: row.id },
            React.createElement(CMP.Silk, { src: row.src }),
            React.createElement(CMP.Fixture, { top: row.fixture.top, bottom: row.fixture.bottom }),
            React.createElement(CMP.BetBtn, { odds: betButtonOdds, modifier: modifier, handler: row.handler, isDisabled: row.isNR })));
    }
    /* istanbul ignore next */
    renderCardRows(rows) {
        /* istanbul ignore next */
        return (React.createElement("div", { className: "rj-racing-next-races__rows", style: { height: `${this.state.dataProvider.nextRacesRowsHeight}px` } }, rows.map(x => {
            /* istanbul ignore next */
            return this.renderCardRow(x);
        })));
    }
    /* istanbul ignore next */
    renderLoader(shouldSetStyles) {
        const styles = shouldSetStyles ? { height: `${this.state.dataProvider.nextRacesRowsHeight}px` } : {};
        return (React.createElement("div", { className: "rj-racing-next-races__loader", style: styles },
            React.createElement(Loader, null)));
    }
    /* istanbul ignore next */
    renderCardItems(items) {
        /* istanbul ignore next */
        return items.map(x => {
            /* istanbul ignore next */
            return this.renderCardItem(x);
        });
    }
    /* istanbul ignore next */
    scrollLeft() {
        /* istanbul ignore next */
        let t = this.anims.left + this.calcs.step;
        /* istanbul ignore next */
        this.anims.left = t > 0 ? 0 : t;
        /* istanbul ignore next */
        let o = Object.assign(Object.assign({}, this.state.animation), { x: this.anims.left });
        /* istanbul ignore next */
        this.setState({ animation: o });
    }
    /* istanbul ignore next */
    scrollRight() {
        /* istanbul ignore next */
        let t = this.anims.left - this.calcs.step;
        /* istanbul ignore next */
        let d = this.calcs.container - this.calcs.wrapper;
        /* istanbul ignore next */
        this.anims.left = Math.abs(t) > d ? d * -1 : t;
        /* istanbul ignore next */
        let o = Object.assign(Object.assign({}, this.state.animation), { x: this.anims.left });
        /* istanbul ignore next */
        this.setState({ animation: o });
    }
    /* istanbul ignore next */
    onClickArrowsHandler(direction, e) {
        /* istanbul ignore next */
        return this["scroll" + direction]();
    }
    // to be used for routing between captured events
    /* istanbul ignore next */
    handleEvent(e) {
        /* istanbul ignore next */
        if (e.type === "resize") {
            this.resetScroll();
            this.shouldScroll();
        }
    }
    /* istanbul ignore next */
    resetScroll() {
        this.anims.left = 0;
        this.setState({
            animation: Object.assign(Object.assign({}, this.state.animation), { x: 0 })
        });
    }
    /* istanbul ignore next */
    shouldScroll() {
        if (this.races__container && this.races__wrapper) {
            let sLeft = this.anims.left < 0 ? true : false;
            let sRight = this.calcs.container - this.calcs.wrapper + this.anims.left > 0 ? true : false;
            if (this.state.scrollable.left !== sLeft ||
                this.state.scrollable.right !== sRight) {
                this.setState({
                    scrollable: {
                        left: sLeft,
                        right: sRight
                    }
                });
            }
        }
    }
    /* istanbul ignore next */
    setupCalcs() {
        if (this.races__container && this.races__wrapper) {
            this.calcs.container = this.races__container.offsetWidth;
            this.calcs.wrapper = this.races__wrapper.offsetWidth;
            let items = this.races__container.querySelectorAll(".rj-racing-next-races__item");
            let i = items[0]["offsetWidth"];
            let dI = i * items.length;
            let dC = (this.calcs.container - dI) / (items.length - 1);
            this.calcs.step = i + dC;
        }
    }
    /* istanbul ignore next */
    componentWillUnmount() {
        window.removeEventListener("resize", this);
    }
    /* istanbul ignore next */
    componentDidMount() {
        this.setupCalcs();
        this.shouldScroll();
        window.addEventListener("resize", this);
    }
    /* istanbul ignore next */
    getSnapshotBeforeUpdate(prevProps, prevState) {
        if (this.cachedState.branchId !== this.state.dataProvider.racingStore.branchId ||
            this.cachedState.regionId !== this.state.dataProvider.racingStore.regionId) {
            return {
                branchId: this.state.dataProvider.racingStore.branchId,
                regionId: this.state.dataProvider.racingStore.regionId
            };
        }
        /* tslint:disable:no-null-keyword */
        return null;
        /* tslint:enable:no-null-keyword */
    }
    /* istanbul ignore next */
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (snapshot !== null) {
            this.cachedState = snapshot;
            this.resetScroll();
        }
        this.setupCalcs();
        this.shouldScroll();
    }
    /* istanbul ignore next */
    render() {
        let l = this.state.dataProvider.getNextRaces.length;
        let cls = "rj-racing-next-races rj-racing-next-races--nextGames";
        cls += this.state.scrollable.left ? " rj-racing-next-races--sLeft" : "";
        cls += this.state.scrollable.right ? " rj-racing-next-races--sRight" : "";
        return (React.createElement(React.Fragment, null, this.state.dataProvider.racingStore.isNextRacesAvailable &&
            React.createElement("div", { className: cls },
                React.createElement(CMP.Heading, { more: this.dict.ViewNextCoupons, title: this.dict.NextRaces.format(this.state.dataProvider.getNextRaces.length) }),
                React.createElement("div", { className: "rj-racing-next-races__wrapper", ref: n => this.races__wrapper = n },
                    (!l && !this.state.dataProvider.isDataLoaded) && this.renderLoader(),
                    (l > 0) && (React.createElement(Animate, { animation: this.state.animation },
                        React.createElement("div", { className: "rj-racing-next-races__container", ref: n => this.races__container = n }, this.renderCardItems(this.state.dataProvider.getNextRaces))))),
                (l > 0 && this.state.dataProvider.isDataLoaded) && React.createElement(CMP.Arrow, { handler: this.onClickArrowsHandler.bind(this, "Left"), classModifier: "left", text: React.createElement(Icon, { i: "i-12 arrow-flat-left" }) }),
                (l > 0 && this.state.dataProvider.isDataLoaded) && React.createElement(CMP.Arrow, { handler: this.onClickArrowsHandler.bind(this, "Right"), classModifier: "right", text: React.createElement(Icon, { i: "i-12 arrow-flat-right" }) }))));
    }
};
__decorate([
    Debounce(50),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, MouseEvent]),
    __metadata("design:returntype", void 0)
], RacingNextRaces.prototype, "onClickArrowsHandler", null);
__decorate([
    Debounce(50),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Event]),
    __metadata("design:returntype", void 0)
], RacingNextRaces.prototype, "handleEvent", null);
__decorate([
    Debounce(50),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], RacingNextRaces.prototype, "shouldScroll", null);
RacingNextRaces = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], RacingNextRaces);
export { RacingNextRaces };
//# sourceMappingURL=RacingNextRaces.js.map